/**
 * ueditorForNotice 公告编辑器
 * author Qian.qianchen 2019-06-28
 */
'use strict';
angular
    .module('util.ueditorForNotice', [
        'util.ueditorConfig',
        'util.ueditorServiceModule',
        'eyeProtectionModelModule',
        'ueditorPlugInModule',
        // 'ueditorForNoticeBtnServiceModule',
    ])
    .directive('ueditorForNotice', [
        '$timeout',
        '$sce',
        '$q',
        '$modal',
        '$interval',
        'localStorageService',
        'trsUeditorConfigService',
        'modalDialog',
        'ueditorService',
        '$compile',
        '$window',
        '$stateParams',
        'ueditorPlugIn',
        function(
            $timeout,
            $sce,
            $q,
            $modal,
            $interval,
            localStorageService,
            trsUeditorConfigService,
            modalDialog,
            ueditorService,
            $compile,
            $window,
            $stateParams,
            ueditorPlugIn
        ) {
            return {
                restrict: 'E',
                scope: {
                    list: '=',
                    type: '@',
                    versionid: '=',
                    infullscreen: '=', // 是否处在全屏状态
                    metadataid: '=',
                    draftType: '@', // 稿件类型
                    hasContent: '=', // 编辑器内是否有内容
                },
                replace: true,
                // templateUrl: './lib/ueditor/ueditor.html',
                template:
                    "<div type='_notice'><script id='ueditor' style='width:100%;position:relative'></script><div class='trs_ueditor_selectionNum'></div></div>",
                link: function(scope, element, attrs, ctrl) {
                    /* require(['./lib/ueditor2/ueditor.config', './lib/ueditor2/ueditor.all'], function() {*/
                    var tempArrary = [];
                    var editorToolBar = ueditorService.getToolBar();
                    var indexArray = [4, 5, 6, 7, 8, 11, 18, 17, 29, 27, 28, 31, 43, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 48, 45, 46, 47];
                    editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                    var ue = UE.getEditor('ueditor', editorToolBar);
                    var domUtils = baidu.editor.dom.domUtils;
                    ue.ready(function() {
                        // scope.list.HTMLCONTENT = ueditorService.replaceHtmlBlank(scope.list.HTMLCONTENT); //将半角空格换为全角空格
                        scope.list.HTMLCONTENT = scope.list.HTMLCONTENT.replace(
                            /<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g,
                            '<hr ispageseparator="true"/>'
                        ); // 替换分页符标签，用于编辑器展示
                        ue.setContent(scope.list.HTMLCONTENT);
                        // 纯文本正文及字数
                        var preContent = ueditorService.getTextContent(ue.getContentTxt());
                        scope.list.DOCWORDSCOUNT = preContent
                            .replace(/\n/g, '')
                            .replace(/\u0020/g, '')
                            .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                        // 纯文本正文及字数
                        var preResult = $sce.getTrustedHtml(
                            "<div class='display_none ueditorWordCount'>已输入<span class='color-red'>{{list.DOCWORDSCOUNT}}</span>个字</div>"
                        );
                        var result = $compile(preResult)(scope);
                        // element.find('.edui-editor').append(result);
                        element.find('.edui-editor-toolbarboxinner').append(result);
                        var destroyWatch = scope.$watch('list.DOCWORDSCOUNT', function(newValue) {
                            if (newValue) {
                                $timeout(function() {
                                    result.removeClass('display_none');
                                    destroyWatch();
                                });
                            }
                        });
                        ue.getOpt('lang');
                        var promise_keyup;
                        var promise_contentChange;
                        var promise_mouseup;
                        ue.addListener('keyup', function() {
                            // 实时双向绑定开始
                            bindContent(promise_keyup);
                        });
                        ue.addListener('contentChange', function() {
                            // 实时双向绑定开始
                            bindContent(promise_contentChange);
                            // 编辑器的必填提示
                            $timeout(function() {
                                var content = ue.getContent();
                                if (content !== '') {
                                    scope.hasContent = true;
                                } else {
                                    scope.hasContent = false;
                                }
                            });
                        });
                        // 计算显示字数，并显示出来
                        domUtils.on(ue.body, 'mouseup', function(event) {
                            selectionNumPop(event);
                        });
                        domUtils.on(ue.body, 'keydown', function(event) {
                            selectionNumPop(event);
                        });
                        // 显示选中区域的字数
                        ue.addListener('selectionchange', function() {
                            var selectionStr = this.selection.getText();
                            if (selectionStr.length === 0) {
                                hideSelectionNum();
                            }
                        });
                        // 编辑器失焦是字数显示消失
                        ue.addListener('blur', function() {
                            hideSelectionNum();
                        });

                        /**
                         * [showSelectionNum methodname]显示选中字数统计
                         * @return {[type]} [description] null
                         */
                        function showSelectionNum(position) {
                            var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                            selectionNumDiv.css('left', position.left + 'px');
                            selectionNumDiv.css('top', position.top + 'px');
                            selectionNumDiv.fadeIn('fast');
                        }

                        /**
                         * [hideSelectionNum methodname]显示选中字数统计
                         * @return {[type]} [description] null
                         */
                        function hideSelectionNum() {
                            $(document)
                                .find('.trs_ueditor_selectionNum')
                                .fadeOut('fast');
                        }

                        /**
                         * [showSelectionNum methodname]显示选中字数统计
                         * @return {[type]} [description] null
                         */
                        function selectionNumPop(event) {
                            var selectionStr = ue.selection.getText();
                            if (selectionStr.length !== 0) {
                                var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                                var position = {};
                                selectionNumDiv.html(
                                    '已选中' +
                                        selectionStr
                                            .replace(/&nbsp;/g, '')
                                            .replace(/\u00a0/g, '')
                                            .replace(/\u3000/g, '')
                                            .replace(/\n/, '').length +
                                        '个字'
                                );
                                showSelectionNum(position);
                            } else {
                                hideSelectionNum();
                            }
                        }
                        // ueditorService.compareLocalAndServe(scope, scope.type).then(function() {
                        //     scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                        // });
                        // MLFWEB-5014 修复全屏的bug
                        ue.addListener('fullscreenchanged', function(type, bfullscreen) {
                            scope.infullscreen = bfullscreen;
                            var $iframeHolder = $('.edui-editor-iframeholder');
                            $iframeHolder.css('width', '100%');
                            // 全屏需要出滚动条
                            // $timeout(function() {
                            // });
                            //
                            var doc = $iframeHolder.find('iframe')[0].contentWindow.document;
                            doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
                            if (!bfullscreen) {
                                doc.body.style.height = 'initial';
                            }
                            $timeout(function() {
                                ue.selection.getRange().collapsed = true;
                                ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
                                ue.execCommand('inserthtml', '<trsfullscreen></trsfullscreen>');
                                var doms = doc.getElementsByTagName('trsfullscreen');

                                for (var index = 0; index < doms.length; index++) {
                                    doms[index].parentNode.removeChild(doms[index]);
                                }

                                ue.fireEvent('contentChange');
                            });
                        });
                    });
                    scope.$on('$destroy', function() {
                        $interval.cancel(scope.promise); // 销毁定时事件
                    });

                    /**
                     * [initStatus methodname]绑定数据和编辑器内容
                     * @return {[type]} [description] null
                     */
                    function bindContent(promise) {
                        if (promise) {
                            $timeout.cancel(promise);
                            promise = null;
                        }
                        promise = $timeout(function() {
                            scope.list.DOCWORDSCOUNT = ueditorService.getDOCWORDSCOUNT(ue)
                        }, 500);
                        return promise;
                    }

                    /**
                     * [localcache methodname]本地保存
                     * @return {[type]} [description] null
                     */
                    function localcache() {
                        ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
                    }

                    // 监控metadataid变化，并将正文更新进入本地版本
                    ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);

                    // 重写全屏方法
                    ueditorService.rewriteFullScreen(UE, 60);
                    scope.$on('$destroy', function() {
                        ueditorService.destroyCommonUe(ue);
                    });
                    ueditorPlugIn.spaceIndent(ue, domUtils);
                    ueditorPlugIn.fixContentInImageWrap(ue);
                    ueditorPlugIn.fixPasteFromMicoWord(ue);
                },
            };
        },
    ]);
